var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyboardingOnlineLabLogoSignInPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Student_Splash_Page",
    "data-name": "Student Splash Page",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 330 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #124c72;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        filter: url(#drop-shadow-3);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    x: 48.81,
    y: -1.19,
    width: 240,
    height: 79,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.08,
    dy: 2.46
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1.23
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Keyboarding_Online_Lab_Logo",
    "data-name": "Keyboarding Online Lab Logo",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.08,22.77h-8.62l-5.15-9.54h-.06v9.54h-6.94V.92h6.94v9.02h.06L62.27.92h8.47l-7.21,10.28,7.55,11.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M79.43,6.57v2.49h8.56v5.49h-8.56v2.58h9.36v5.65h-16.29V.92h16.14v5.65h-9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.88,22.77h-6.94v-7.73l-7.52-14.12h7.58l1.53,3.68c.71,1.69,1.38,3.56,1.84,5.34h.06c.46-1.78,1.14-3.65,1.84-5.34l1.53-3.68h7.58l-7.52,14.12v7.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.33.92c5.43,0,7.95,2.27,7.95,5.65,0,2.55-1.07,4.02-3.53,4.82v.06c2.61.61,4.11,2.45,4.11,5.09,0,3.8-3.1,6.23-8.38,6.23h-10.1V.92h9.94ZM119.02,9.42h1.93c1.78,0,2.58-.58,2.58-1.78s-.77-1.78-2.42-1.78h-2.09v3.56ZM119.02,17.8h2.03c1.87,0,2.61-.52,2.61-1.84s-.8-1.9-2.7-1.9h-1.93v3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.61,11.85c0,6.93-4.33,11.41-11.05,11.41s-11.05-4.48-11.05-11.41S136.85.43,143.57.43s11.05,4.48,11.05,11.42ZM139.85,11.85c0,3.65,1.26,5.58,3.71,5.58s3.71-1.93,3.71-5.58-1.26-5.58-3.71-5.58-3.71,1.93-3.71,5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.47,19.55l-.86,3.22h-7.33l7.21-21.85h8.78l7.21,21.85h-7.33l-.86-3.22h-6.81ZM167.5,12.71c-.58-2.18-1.14-4.57-1.6-6.78h-.06c-.46,2.21-1.01,4.6-1.6,6.78l-.4,1.53h4.05l-.4-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.23.92c5.74,0,8.16,2.3,8.16,6.32,0,2.7-1.53,4.51-4.11,5.34v.06c1.63.58,2.45,1.78,3.53,4.69l1.96,5.43h-7.3l-1.47-4.45c-.71-2.03-1.5-2.76-3.34-2.76h-1.04v7.21h-6.94V.92h10.56ZM185.61,10.68h2.33c1.96,0,2.76-.92,2.76-2.42,0-1.6-1.04-2.27-2.88-2.27h-2.21v4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.61.92c7.55,0,11.78,3.93,11.78,10.92s-4.23,10.92-11.78,10.92h-8.71V.92h8.71ZM207.83,16.97h1.53c3.01,0,4.76-1.9,4.76-5.12s-1.75-5.12-4.76-5.12h-1.53v10.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.19,22.77V.92h6.94v21.85h-6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.11,22.77l-2.98-8.13c-.98-2.67-1.9-5.46-2.7-8.19h-.06c.18,2.88.25,5.77.25,8.65v7.67h-6.63V.92h10.16l2.98,8.13c.98,2.67,1.9,5.46,2.7,8.19h.06c-.18-2.88-.25-5.77-.25-8.65V.92h6.63v21.85h-10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.08,8.19h-7.36c-.18-1.44-1.1-2.36-2.64-2.36-2.27,0-3.71,2.33-3.71,6.11s1.44,6.23,3.81,6.23c1.96,0,3.25-1.38,3.38-3.28h-3.71v-4.91h10.19v12.8h-5.98v-1.93h-.06c-1.32,1.63-3.19,2.39-5.52,2.39-5.83,0-9.39-4.3-9.39-11.29s4.17-11.51,11.05-11.51c5.74,0,9.73,3.1,9.97,7.76Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.09,
    y: 36.04,
    width: 230.87,
    height: 34.46
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M109.95,53.43c0,5.7-3.14,9.29-8.11,9.29s-8.11-3.59-8.11-9.29,3.14-9.29,8.11-9.29,8.11,3.59,8.11,9.29ZM96.15,53.43c0,4.39,2.18,7.18,5.7,7.18s5.7-2.79,5.7-7.18-2.21-7.18-5.7-7.18-5.7,2.79-5.7,7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.21,62.36l-4.24-7.71c-1.48-2.66-2.94-5.35-4.32-8.01h-.05c.05,2.86.08,5.7.08,8.56v7.15h-2.26v-17.87h3.39l4.27,7.71c1.46,2.66,2.91,5.35,4.32,8.01h.05c-.05-2.86-.08-5.7-.08-8.56v-7.15h2.26v17.87h-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.82,60.3v2.06h-11.45v-17.87h2.31v15.81h9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M146.46,62.36v-17.87h2.31v17.87h-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M164.33,62.36l-4.24-7.71c-1.48-2.66-2.94-5.35-4.32-8.01h-.05c.05,2.86.08,5.7.08,8.56v7.15h-2.26v-17.87h3.39l4.27,7.71c1.46,2.66,2.91,5.35,4.32,8.01h.05c-.05-2.86-.08-5.7-.08-8.56v-7.15h2.26v17.87h-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.8,46.55v5.65h8.69v2.03h-8.69v6.07h9.49v2.06h-11.8v-17.87h11.52v2.06h-9.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.23,60.3v2.06h-11.45v-17.87h2.31v15.81h9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.75,57.04l-1.96,5.32h-2.46l6.78-17.87h3.14l6.8,17.87h-2.49l-1.93-5.32h-7.88ZM217.3,53.38c-.9-2.49-1.73-4.79-2.59-7.28h-.05c-.85,2.48-1.68,4.79-2.59,7.28l-.6,1.63h6.4l-.58-1.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.86,44.49c4.12,0,6.02,1.83,6.02,4.54,0,2.01-1.03,3.46-2.96,4.17v.05c2.13.5,3.36,2.01,3.36,4.19,0,2.99-2.18,4.92-5.95,4.92h-6.3v-17.87h5.82ZM227.35,52.3h3.34c2.81,0,3.92-1.13,3.92-2.94s-1.13-2.91-3.81-2.91h-3.44v5.85ZM227.35,60.4h3.66c2.64,0,3.89-1.08,3.89-3.09s-1.23-3.09-4.22-3.09h-3.34v6.17Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardingOnlineLabLogoSignInPage);
export default __webpack_public_path__ + "static/media/Keyboarding-Online-Lab-Logo_Sign-In-Page.10b560aedc3537cd1edf764efddef58f.svg";
export { ForwardRef as ReactComponent };